module.exports = __webpack_public_path__ + "img/chevron-left-duo.f3974152.svg";